import React from 'react';
import { ArrowLeft, ArrowRight, Eye, EyeOff, Square } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface Props {
  busy: boolean;
  canGoPrevious: boolean;
  canGoNext: boolean;
  isBlackout: boolean;
  onPrevious: () => void;
  onNext: () => void;
  onToggleBlackout: () => void;
  onEnd: () => void;
}

/** Bediening van de live sessie: vorige/volgende/zwart scherm/beëindigen.
 * Bevat bewust geen slide-inhoud of privénotities -- puur de knoppen, zodat
 * dit onderdeel ook los herbruikbaar is (bijv. een presentatieteam-fallback
 * zonder sprekersweergave eromheen). */
export default function PresentationControls({
  busy, canGoPrevious, canGoNext, isBlackout, onPrevious, onNext, onToggleBlackout, onEnd,
}: Props) {
  return (
    <div className="space-y-2">
      <div className="grid grid-cols-2 gap-2">
        <Button variant="secondary" disabled={busy || !canGoPrevious} onClick={onPrevious}>
          <ArrowLeft className="mr-2 h-4 w-4" /> Vorige
        </Button>
        <Button disabled={busy || !canGoNext} onClick={onNext}>
          Volgende <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </div>

      <Button variant={isBlackout ? 'default' : 'outline'} disabled={busy} onClick={onToggleBlackout} className="w-full">
        {isBlackout ? <Eye className="mr-2 h-4 w-4" /> : <EyeOff className="mr-2 h-4 w-4" />}
        {isBlackout ? 'Zwart scherm uit' : 'Zwart scherm aan'}
      </Button>

      <Button variant="ghost" className="w-full text-red-400 hover:text-red-300" disabled={busy} onClick={onEnd}>
        <Square className="mr-2 h-4 w-4" /> Sessie beëindigen
      </Button>
    </div>
  );
}
